const state = {
	order: {
		actualPaid: null,
		amount: null,
		contactId: null,
		courses: [],
		createdAt: null,
		discount: null,
		ipAddr: null,
		orderId: null,
		rpId: null,
		status: null,
		transactionId: null,
		userAgent: null,
		customerInfo: {
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			relationshipToStudent: ""
		},
	},
}

const mutations = {
	'Update_Order'(state, order) {
		state.order = order;
	},
	'Clear_Courses'(state){
		state.order.courses = [];
	},
	'Clear_Order'(state) {
		state.order = {
			actualPaid: null,
			amount: null,
			contactId: null,
			courses: null,
			createdAt: null,
			discount: null,
			ipAddr: null,
			orderId: null,
			rpId: null,
			status: null,
			transactionId: null,
			userAgent: null,
			customerInfo: {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				relationshipToStudent: ""
			},
		};
	},
	'Update_Course_Assignments'(state, courses) {
		state.order.courses = courses;
	},
	'Add_Students'(state, students) {

		if (!state.order.students) {
			state.order.students = [];
		}

		// console.log('adding student to vuex')
		// console.log(students);

		if (students && students.length > 0) {
			students.forEach(student => {
				const existIndex = state.order.students.findIndex(s => s.id == student.id);
				// console.log(`find index of student using id ${student.id} at index ${existIndex}`)
				//add to student list if not exists
				if (existIndex < 0) {
					state.order.students.push(student);
				}
			});
		}
		else {
			state.order.students = [];
		}
	},
	'Remove_Students'(state, students) {

		if (!state.order.students) {
			return;
		}

		if (students && students.length > 0) {
			students.forEach(student => {
				const existIndex = state.order.students.findIndex(s => s.id == student.id);
				// console.log(`find index of student using id ${student.id} at index ${existIndex}`)
				//add to student list if not exists
				if (existIndex >= 0) {
					state.order.students.splice(existIndex, 1);
				}
			});
		}
	}
}

const actions = {
	updateOrder: ({ commit }, order) => {
		commit('Update_Order', order);
	},
	clearOrder: ({ commit }) => {
		commit('Clear_Order');
	},
	clearCourses: ({ commit }) => {
		commit('Clear_Courses');
	},
	updateCourseAssignments: ( {commit}, courses ) => {
		commit('Update_Course_Assignments', courses);
	},
	addStudents: ({ commit }, students) => {
		commit('Add_Students', students);
	},
	removeStudents: ({ commit }, students) => {
		commit('Remove_Students', students);
	},
}

const getters = {
	order: (state) => {
		return state.order;
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}